import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.19 1.25a.625.625 0 00-.626.625v.856H4.82a2.831 2.831 0 00-2.825 2.832v.63h14.093v-.63a2.831 2.831 0 00-2.825-2.832h-.746v-.856a.625.625 0 10-1.25 0v.856H6.814v-.856a.625.625 0 00-.625-.625zM1.993 14a2.831 2.831 0 002.825 2.831h4.05a5.37 5.37 0 01-.507-2.281c0-3 2.444-5.444 5.45-5.444.813 0 1.582.181 2.275.5V7.444H1.994V14zm7.05-4.431h.006c.35 0 .625.281.625.625a.623.623 0 01-.625.625.627.627 0 01-.625-.625c0-.344.275-.625.619-.625zm-3.232 0h.007c.343 0 .625.281.625.625a.627.627 0 01-.625.625.627.627 0 01-.625-.625c0-.344.275-.625.618-.625zm0 2.631h.007c.343 0 .625.281.625.625 0 .35-.282.625-.625.625a.623.623 0 01-.625-.625c0-.344.275-.625.618-.625z"
        fill={props.color ?? "#23262F"}
      />
      <path
        d="M13.813 10.356a4.2 4.2 0 00-4.2 4.194c0 2.319 1.88 4.2 4.2 4.2a4.2 4.2 0 004.193-4.2 4.198 4.198 0 00-4.194-4.194zm1.956 4.882a.623.623 0 01-.588.418.595.595 0 01-.206-.037l-1.369-.475a.628.628 0 01-.418-.594v-1.369c0-.343.274-.625.624-.625.344 0 .626.282.626.625v.925l.95.332a.627.627 0 01.38.8z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
